import * as API from "../../api";

// Redux Action

export const sso_verify_link_request = (link, pin, cb) => (dispatch) => {
  API.verifyLink(link, pin)
    .then((response) => {
      const { status, msg, extra = {} } = response;

      if (status && status >= 200 && status < 300) {
        cb({ status: status, msg, extra });
      } else {
        cb({ status, err: msg });
      }
    })
};
